export function shouldShowConversationNavigation(context) {
  return Boolean(context?.previousCall || context?.nextCall);
}
